import { validateComponent } from '../../../utils'

const eSignatureValidator = (component) => {
  const {
    options: { isRequired, requiredErrorMessage, submission },
  } = component

  if (isRequired) {
    const validators = [
      {
        validationFunction: () =>
          submission && (submission.value || '').trim().length > 0,
        validationKey: 'value',
        validationMessage: requiredErrorMessage,
      },
      {
        validationFunction: () => submission && submission.policyAccepted,
        validationKey: 'policy',
        validationMessage: 'You must accept the e-signature policiy!',
      },
    ]
    validateComponent(component, validators)
  } else {
    component.isValid = true
  }

  return component.isValid
}

export default eSignatureValidator
